export const BEDROCK_DATABASE_KEY_INPUT_MAX_LENGTH = 255;
export const BEDROCK_DATABASE_KEY_MAX_LENGTH = 63;
export const BEDROCK_DATABASE_KEY_PATTERN = /^[a-z][\d_a-z]*$/;
export const BEDROCK_DATABASE_KEY_PATTERN_MESSAGE =
  "must be lower-snake-case starting with a letter";
export const BEDROCK_DATABASE_KEY_NORMALIZED_PATTERN_MESSAGE =
  "must normalize to lower-snake-case starting with a letter";

export function normalizeBedrockDatabaseKey(value: string): string {
  return value
    .trim()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/([\da-z])([A-Z])/g, "$1_$2")
    .toLowerCase()
    .replace(/[^\da-z]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .replace(/_+/g, "_");
}
